import React from "react";
import Header from "../../../Home/Header";
import Footer from "../../../Home/Footer";
import DeFiSmartContractHero from "./DeFiSmartContractHero";
import OurDeFiSmartC from "./OurDeFiSmartC";

function DeFiSmartContract() {
  return (
    <div>
      <Header />
      <DeFiSmartContractHero />
      <OurDeFiSmartC />
      <Footer />
    </div>
  );
}

export default DeFiSmartContract;
